import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilterMenuService {

  constructor(private http: HttpClient) { }

  url = `${environment.url}/revenue-month-year`

  getById(id?: number) {
    return this.http
      .get(`${this.url}/${id}`) as Observable<any>;
  }
  
}
